import Vue from 'vue'
import VueRouter from 'vue-router'
import newOrder from './components/newOrder.vue'
import pendingAnswerOrder from './components/pendingAnswerOrder.vue'
import processedOrder from './components/processedOrder.vue'
import canceledOrder from './components/canceledOrder.vue'
import approvedOrder from './components/approvedOrder.vue'
import refundedOrder from './components/refundedOrder.vue'
import purchasedOrder from './components/purchasedOrder.vue'
import warehouseDeliveredOrder from './components/warehouseDeliveredOrder.vue'
import intShipmentOrder from './components/intShipmentOrder.vue'
import branchDeliveredOrder from './components/branchDeliveredOrder.vue'
import pendingToBranchOrder from './components/pendingToBranchOrder.vue'
import user from './components/user/user.vue'
import userProfile from './components/user/userProfile.vue'
import regularUser from './components/user/regularUser.vue'
import userDeliveredOrder from './components/userDeliveredOrder.vue'
import credit from './components/user/user_credit/credit.vue'
import creditLogTransaction from './components/logs/creditLogTransaction.vue'
import creditLogAction from './components/logs/creditLogAction.vue'
import coupon from './components/coupons/coupon.vue'
import home from './components/home.vue'
import myOrder from './components/customer/myOrders.vue'
import myOrderCases from './components/customer/myOrderCases.vue'
import myExportOrders from './components/customer/exportOrder/myExportOrders.vue'
import addExportOrder from './components/customer/exportOrder/addExportOrder.vue'
import myExportOrderDetail from './components/customer/exportOrder/myExportOrderDetail.vue'
import archivedOrder from './components/customer/archivedOrder.vue'
import invoice from './components/customer/invoices.vue'
import orderDetail from './components/customer/orderDetail.vue'
import makeNewOrder from './components/customer/makeNewOrder.vue'
import addNewShipOnly from './components/customer/addNewShipOnly.vue'
import chargeBalance from './components/customer/chargeBalance.vue'
import orderLog from './components/orderLog.vue'
import secret from './components/secret.vue'
import customerCreditInvoice from './components/customer/customerCreditInvoice.vue'
import customerOrderInvoice from './components/customer/customerOrderInvoices.vue'
import payWithFib from './components/customer/payWithFib.vue'
import payWithFastPay from './components/customer/payWithFastPay.vue'
import checkRate from './components/customer/checkRate.vue'
import exportableOrder from './components/exportableOrder.vue'
import allOrder from './components/allOrder.vue'
import warehouseDatePassed from './components/warehouseDatePassed.vue'
import customerPrices from './components/customerPrices'
import kreenexFeePrices from './components/kreenexFeePrices'
import shippingPrices from './components/shippingPrices'
import banks from './components/bank/banks'
import ExchangeRate from './components/exchangeRate/exchangeRate'
import DeliveredReport from './components/report/deliveredReport'
import loanedCustomers from './components/user/loanedCustomers.vue'
import ShipOnly from './components/shipOnly.vue'
import Supplier from './components/supplier/suppliers.vue'
import ExpenseType from './components/expenseType/expenseTypes.vue'
import Expense from './components/expense/expenses.vue'
import OrderInvoice from './components/orderInvoice/orderInvoices.vue'
import Capital from './components/capital.vue'
import Profit from './components/profit.vue'
import MoneyTransfer from './components/moneyTransfer/moneyTransfer.vue'
import PutMoney from './components/putMoney/putMoney.vue'
import Role from './components/roles/roles.vue'
// import Branch from './components/branch/branches.vue'
import partialRefundInvoices from './components/partialRefundInvoices.vue'
import customerPartialRefundInvoices from './components/customer/customerPartialRefundInvoices.vue'
import DeliveryInvoice from './components/deliveryInvoice/deliveryInvoices.vue'
import PurchaseHistory from './components/purchaseHistory.vue'
import City from './components/city/city.vue'
import NotFoundOrder from './components/notFoundOrder/notFoundOrders.vue'
import OrderCases from './components/orderCase/orderCases.vue'
import OrderCaseUsers from './components/orderCase/orderCaseUsers.vue'
import customerRegistration from './components/customerRegistration.vue'
import homeSlider from './components/homeSlider/homeSlider.vue'
import popularWebsite from './components/popularWebsite/popularWebsite.vue'
import globalWebsiteGroup from './components/globalWebsite/globalWebsiteGroup.vue'
import globalWebsite from './components/globalWebsite/globalWebsite.vue'
import orderDelivery from './components/orderDelivery/orderDeliveries.vue'
import sendNotification from './components/notification/sendNotification.vue'
import pendingExportOrder from './components/exportOrder/pendingExportOrder.vue'
import processedExportOrder from './components/exportOrder/processedExportOrder.vue'
import canceledExportOrder from './components/exportOrder/canceledExportOrder.vue'
import approvedExportOrder from './components/exportOrder/approvedExportOrder.vue'
import sentExportOrder from './components/exportOrder/sentExportOrder.vue'
import receivedExportOrder from './components/exportOrder/receivedExportOrder.vue'
import currencyRate from './components/currencyRate/currencyRate.vue'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/customer-registration',
      component: customerRegistration
    },
    // {
    //   path: '/branch',
    //   component: Branch
    // },
    {
      path: '/send-notification',
      component: sendNotification
    },
    {
      path: '/roles',
      component: Role
    },
    {
      path: '/put_money',
      component: PutMoney
    },
    {
      path: '/partial-refund',
      component: partialRefundInvoices
    },
    {
      path: '/not-found-orders',
      component: NotFoundOrder
    },
    {
      path: '/order-cases',
      component: OrderCases
    },
    {
      path: '/order-case-progress',
      component: OrderCaseUsers
    },
    {
      path: '/customer-partial-refund',
      component: customerPartialRefundInvoices
    },
    {
      path: '/delivery-invoice',
      component: DeliveryInvoice
    },
    {
      path: '/purchase-history',
      component: PurchaseHistory
    },
    {
      path: '/export-order/pending',
      component: pendingExportOrder
    },
    {
      path: '/export-order/processed',
      component: processedExportOrder
    },
    {
      path: '/export-order/canceled',
      component: canceledExportOrder
    },
    {
      path: '/export-order/approved',
      component: approvedExportOrder
    },
    {
      path: '/export-order/sent',
      component: sentExportOrder
    },
    {
      path: '/export-order/received',
      component: receivedExportOrder
    },
    {
      path: '/profit',
      component: Profit
    },
    {
      path: '/money-transfer',
      component: MoneyTransfer
    },
    {
      path: '/capital',
      component: Capital
    },
    {
      path: '/expense-type',
      component: ExpenseType
    },
    {
      path: '/expense',
      component: Expense
    },
    {
      path: '/order_invoice',
      component: OrderInvoice
    },
    {
      path: '/supplier',
      component: Supplier
    },
    {
      path: '/ship-only',
      component: ShipOnly
    },
    {
      path: '/loan-customers',
      component: loanedCustomers
    },
    {
      path: '/delivered-report',
      component: DeliveredReport
    },
    {
      path: '/exchange-rate',
      component: ExchangeRate
    },
    {
      path: '/banks',
      component: banks
    },
    {
      path: '/currency-rate',
      component: currencyRate
    },
    {
      path: '/shipping-prices',
      component: shippingPrices
    },
    {
      path: '/kreenex-fee-prices',
      component: kreenexFeePrices
    },
    {
      path: '/customer-prices',
      component: customerPrices
    },
    {
      path: '/new-order',
      component: newOrder
    },
    {
      path: '/pending-answer-order',
      component: pendingAnswerOrder
    },
    {
      path: '/processed_order',
      component: processedOrder
    },
    {
      path: '/canceled_order',
      component: canceledOrder
    },
    {
      path: '/approved_order',
      component: approvedOrder
    },
    {
      path: '/refunded_order',
      component: refundedOrder
    },
    {
      path: '/purchased_order',
      component: purchasedOrder
    },
    {
      path: '/warehouse_delivered_order',
      component: warehouseDeliveredOrder
    },
    {
      path: '/int_shipment_order',
      component: intShipmentOrder
    },
    {
      path: '/pending_to_branch_order',
      component: pendingToBranchOrder
    },
    {
      path: '/branch_delivery_order',
      component: branchDeliveredOrder
    },
    {
      path: '/',
      component: home
    },
    {
      path: '/users',
      component: user
    },
    {
      path: '/my-profile',
      component: userProfile
    },
    {
      path: '/regular-user',
      component: regularUser
    },
    {
      path: '/user-delivered-order',
      component: userDeliveredOrder
    },
    {
      path: '/credit',
      component: credit
    },
    {
      path: '/credit-log-transaction',
      component: creditLogTransaction
    },
    {
      path: '/credit-log-action',
      component: creditLogAction
    },
    {
      path: '/coupon',
      component: coupon
    },
    {
      path: '/my-order',
      component: myOrder
    },
    {
      path: '/my-order-cases',
      component: myOrderCases
    },
    {
      path: '/my-export-order',
      component: myExportOrders
    },
    {
      path: '/add-new-export-order',
      component: addExportOrder
    },
    {
      path: '/my-export-order-detail/:id',
      component: myExportOrderDetail
    },
    {
      path: '/archived-order',
      component: archivedOrder
    },
    {
      path: '/customer-invoice',
      component: invoice
    },
    {
      path: '/order-detail',
      component: orderDetail
    },
    {
      path: '/make-new-order/:order_id?',
      component: makeNewOrder
    },
    {
      path: '/make-new-ship-only',
      component: addNewShipOnly
    },
    {
      path: '/shipzone-admin',
      component: home
    },
    {
      path: '/order-log',
      component: orderLog
    },
    {
      path: '/secret',
      component: secret
    },
    {
      path: '/customer-credit-invoice',
      component: customerCreditInvoice
    },
    {
      path: '/customer-order-invoice',
      component: customerOrderInvoice
    },
    {
      path: '/charge-balance',
      component: chargeBalance
    },
    {
      path: '/pay-with-fib',
      component: payWithFib
    },
    {
      path: '/pay-with-fastpay',
      component: payWithFastPay
    },
    {
      path: '/check-rate',
      component: checkRate
    },
    {
      path: '/exportable-order',
      component: exportableOrder
    },
    {
      path: '/all-order',
      component: allOrder
    },
    {
      path: '/warehouse-date-passed',
      component: warehouseDatePassed
    },
    {
      path: '/city',
      component: City
    },
    {
      path: '/home-slider',
      component: homeSlider
    },
    {
      path: '/popular-website',
      component: popularWebsite
    },
    {
      path: '/global-website-group',
      component: globalWebsiteGroup
    },
    {
      path: '/global-website-group/:id/sites',
      name: 'global-website-group.sites',
      component: globalWebsite
    },
    {
      path: '/order-delivery',
      component: orderDelivery
    },
    {
      path: '*',
      component: {
        template: `<div width="100%" class="text-center">
                                    <img src="../assets/images/not_found.jpg" alt="">
                                </div>`
      }
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/routes.js